var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.7 14.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.53,3.2a.56.56,0,0,0-.4-.17A6.85,6.85,0,0,1,7.26.22L7.07.09,7,.07,6.81,0,6.7.06,6.53.14l-.06,0,0,0A6.83,6.83,0,0,1,.57,3,.58.58,0,0,0,0,3.62C0,9.85,3.42,13.56,6.61,15l.09,0,.15,0L7,15l.07,0c3.2-1.39,6.62-5.1,6.62-11.33A.59.59,0,0,0,13.53,3.2Zm-1,1c-.19,5.19-3,8.34-5.69,9.6-2.66-1.26-5.5-4.41-5.69-9.6A7.65,7.65,0,0,0,6.85,1.49,7.65,7.65,0,0,0,12.54,4.18Z",
    transform: "translate(0 -0.04)",
    style: {
      fill: "#e83287"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82,7A.64.64,0,0,0,4,7a.55.55,0,0,0,0,.83l2,2,.09.08.19.08.15,0a.64.64,0,0,0,.24-.05.59.59,0,0,0,.17-.1L9.81,6a.52.52,0,0,0,.11-.43.59.59,0,0,0-.26-.39.65.65,0,0,0-.84.14L6.36,8.5ZM6.31,9.7Z",
    transform: "translate(0 -0.04)",
    style: {
      fill: "#e83287"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.934287b7191aa87604e0217ef8bc33ec.svg";
export { ForwardRef as ReactComponent };